export default __webpack_public_path__ + "static/media/CopyIconVideo.4aff16ef.svg";